<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="580px">
      <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="isNuevo ? agregar() : editar()">
        <v-card class="rounded-lg elevation-3 overflow-hidden">
          <!-- Toolbar Header Principal estilo Inspección -->
          <v-toolbar height="58" color="secondary" dark flat class="px-3 px-md-4">
            <v-icon left>{{ isNuevo ? 'mdi-shield-plus' : 'mdi-shield-edit' }}</v-icon>
            <span class="text-h6 font-weight-medium">
              {{ isNuevo ? "Nuevo Rol de Usuario" : "Editar Rol de Usuario" }}
            </span>
            <v-chip
              v-if="!isNuevo"
              color="white"
              text-color="secondary"
              class="font-weight-bold ml-3 px-3 elevation-1"
              style="font-size: 0.95rem; height: 32px"
            >
              <v-icon left size="18" color="secondary">mdi-pound</v-icon>
              ID: {{ Item.id }}
            </v-chip>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="cerrarDialogo()" class="btn-circle-tooltip">
              <v-icon size="20">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text class="pa-4 pa-md-5">
            <!-- SECCIÓN: INFORMACIÓN DEL ROL -->
            <div class="section-title d-flex align-center mb-3">
              <v-icon color="secondary" small class="mr-2">mdi-shield-account</v-icon>
              <span class="text-subtitle-2 font-weight-bold text--primary">
                Información del Rol
              </span>
            </div>

            <!-- Aviso informativo al editar -->
            <v-alert
              v-if="!isNuevo"
              dense
              text
              type="info"
              icon="mdi-information-outline"
              class="rounded-lg mb-3 text-caption"
            >
              El nombre del rol es el identificador en el sistema de permisos y no puede ser modificado.
            </v-alert>

            <v-row dense>
              <!-- Campo Nombre del Rol -->
              <v-col cols="12" class="pa-2">
                <v-text-field
                  label="Nombre del rol *"
                  placeholder="Ej: Administrador, Operador, Supervisor..."
                  hide-details="auto"
                  v-model="Item.name"
                  :disabled="!isNuevo"
                  outlined
                  dense
                  prepend-inner-icon="mdi-shield-outline"
                  class="rounded-lg"
                  :rules="[v => !!v || 'El nombre del rol es requerido']"
                  required
                ></v-text-field>
              </v-col>

              <!-- Campo Descripción -->
              <v-col cols="12" class="pa-2">
                <v-textarea
                  label="Descripción *"
                  placeholder="Describe las responsabilidades o nivel de acceso de este rol..."
                  hide-details="auto"
                  v-model="Item.description"
                  outlined
                  dense
                  rows="3"
                  auto-grow
                  prepend-inner-icon="mdi-text-box-outline"
                  class="rounded-lg"
                  :rules="[v => !!v || 'La descripción es requerida']"
                  required
                ></v-textarea>
              </v-col>
            </v-row>

            <div class="d-flex align-center mt-3 text-caption text--secondary">
              <v-icon x-small color="error" class="mr-1">mdi-asterisk</v-icon>
              <span>Campos obligatorios</span>
            </div>
          </v-card-text>

          <!-- Botones de Acción / Footer -->
          <v-card-actions class="pa-4 bg-light border-top d-flex justify-end align-center">
            <v-btn
              outlined
              color="grey darken-1"
              class="text-capitalize px-4 rounded-lg mr-2 font-weight-medium"
              @click="cerrarDialogo()"
            >
              <v-icon left small>mdi-close</v-icon>
              Cancelar
            </v-btn>

            <v-btn
              v-if="isNuevo"
              color="primary"
              elevation="2"
              class="text-capitalize px-5 rounded-lg font-weight-bold"
              :loading="loading"
              :disabled="loading"
              @click="agregar()"
            >
              <v-icon left small>mdi-content-save</v-icon>
              Guardar Rol
            </v-btn>
            <v-btn
              v-else
              color="primary"
              elevation="2"
              class="text-capitalize px-5 rounded-lg font-weight-bold"
              :loading="loading"
              :disabled="loading"
              @click="editar()"
            >
              <v-icon left small>mdi-pencil</v-icon>
              Actualizar Rol
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { axios2 as axios } from "@/interceptor/useApi";

export default {
  props: ['dialog', 'Item'],
  data() {
    return {
      loading: false,
      valid: false
    };
  },
  computed: {
    isNuevo() {
      return !this.Item || this.Item.id == 0 || this.Item.id == '0' || this.Item.id == null;
    }
  },
  methods: {
    ...mapActions('roles', ["cargarRoles"]),

    async agregar() {
      if (this.$refs.form && !this.$refs.form.validate()) {
        this.$alertify.error("Por favor complete todos los campos requeridos.");
        return;
      }

      this.loading = true;
      const url = "roles/store";
      const data = { role: this.Item };
      try {
        await axios.post(url, data);
        this.$alertify.success("Rol agregado correctamente");
        this.cerrarDialogo();
      } catch (error) {
        this.loading = false;
        const msg = (error.response && error.response.data && error.response.data.error) || "Error al agregar rol";
        this.$alertify.error(msg);
        console.error("error!", error);
      }
    },

    async editar() {
      if (this.$refs.form && !this.$refs.form.validate()) {
        this.$alertify.error("Por favor complete todos los campos requeridos.");
        return;
      }

      this.loading = true;
      const url = "roles/update";
      const data = { role: this.Item };
      try {
        await axios.post(url, data);
        this.$alertify.success("Rol actualizado correctamente");
        this.cerrarDialogo();
      } catch (error) {
        this.loading = false;
        const msg = (error.response && error.response.data && error.response.data.error) || "Error al actualizar rol";
        this.$alertify.error(msg);
        console.error("error!", error);
      }
    },

    cerrarDialogo() {
      this.loading = false;
      this.cargarRoles();
      this.$emit('dialog', false);
    }
  }
};
</script>

<style scoped>
.section-title {
  border-left: 3px solid var(--v-secondary-base, #424242);
  padding-left: 8px;
}

.bg-light {
  background-color: #f8fafc !important;
}

.border-top {
  border-top: 1px solid #e2e8f0 !important;
}

.btn-circle-tooltip {
  background: rgba(255, 255, 255, 0.16) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  border-radius: 50% !important;
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  max-width: 36px !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-decoration: none !important;
  transition: all 0.2s ease-in-out !important;
}

.btn-circle-tooltip:hover {
  background: rgba(255, 255, 255, 0.28) !important;
  border-color: rgba(255, 255, 255, 0.45) !important;
}
</style>
